import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { inviteUser, type InviteUserPayload } from '@/features/users/api'

export function useInviteUserMutation(options?: UseMutationOptions<any, unknown, InviteUserPayload>) {
  return useMutation({
    mutationFn: inviteUser,
    ...options
  })
}
